/**
 * 見出しタブのリンク設定
 */
import { SUnitCategorySetting } from '@/const/ApiSettings'

// ユーザー管理画面のタブ設定
export class TeacherStudentTabSetting {
  static readonly TEACHER: TabLinkSetting = { text: '先生・講師', value: 'TeacherManagement' }
  static readonly STUDENT: TabLinkSetting = { text: '生徒', value: 'StudentManagement' }
}

// 塾・教室管理画面のタブ設定
export class AcademyBranchTabSetting {
  static readonly ACADEMY: TabLinkSetting = { text: '塾管理', value: 'AcademyManagement' }
  static readonly BRANCH: TabLinkSetting = { text: '教室管理', value: 'BranchManagement' }
}

// テスト管理詳細画面のタブ設定
export class StudyDetailTabSetting {
  static readonly LAST_MINUTE_CHECK: TabLinkSetting = {
    text: '直前チェック',
    value: String(SUnitCategorySetting.LAST_MINUTE_CHECK),
  }
  static readonly RESOLVE: TabLinkSetting = { text: '解き直し', value: String(SUnitCategorySetting.RESOLVE) }
}

export type TabLinkSetting = {
  // 表示するテキスト
  text: string
  // タブに設定する値（遷移先ページ名、パラメータ値）
  value: string
}
